var REORDER_QUEUE = [];

function cart_item_added()
{

  //execute scripts when item added to cart

  return true;
}

function checkout_submit()
{
  //execute scripts when checkout process begins

  return true;
}

function reorder(order_id)
{
  REORDER_QUEUE = ORDERS[order_id];
  swal({
    title: "Re-Order",
    text: "Are you sure you would like to add these items back into your cart?",
    type: "warning",
    showCancelButton: true,
    closeOnConfirm: false,
    showLoaderOnConfirm: true,
  },
  function(){
    reorder_process();
  });
  //reorder_process();
}

function reorder_process()
{
  var this_line,this_add;

  // If we still have requests in the queue, let's process the next one.
  if (REORDER_QUEUE.length) {
    this_line = REORDER_QUEUE.shift();

    this_add = {};
    this_add.id = this_line.variant_id;
    this_add.quantity = this_line.quantity;
    this_add.properties = this_line.properties;

    $.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: this_add,
      dataType: "json",
      success: reorder_process,
      fail: function() {
        swal("Re-Order","Errors occurred unfortunately. Please try again.");
      }
    });
  }
  // If the queue is empty, we will redirect to the cart page.
  else {
    document.location.href = '/cart';
  }
}

function subscribe_go(form)
{
  var input_valid = true;
  $(".input-error").removeClass("input-error");
  $(form).find(".required").each(function() {
    var this_val = jQuery.trim($(this).val());
    $(this).val(this_val);
    if(this_val == "")
    {
      $(this).addClass("input-error");
      input_valid = false;
    }
    else if ($(this).attr("type") == "email" && !validateEmail(this_val))
    {
      $(this).addClass("input-error");
      input_valid = false;
    }
  });

  if(input_valid)
  {
    return false;
    $(form).find(".btn").attr('data-txt', $(form).find(".btn").val()).prop('disabled',true).val($(form).find(".btn").attr('data-loading-text'));

    $.ajax({
      type: "POST",
      url: $(form).attr('action'),
      data: $(form).serialize() + "&ajax=1",
      success: function(resp)
      {
        $(form).find(".btn").prop('disabled',false).val($(form).find(".btn").attr('data-txt'));
        if(resp.success)
        {
          $(form).find(".subscribe-entry").hide();
          $(form).find(".subscribe-done").show();
        }
        else
          subscribe_error();
      },
      error: function(resp)
      {
        $(form).find(".btn").prop('disabled',false).val($(form).find(".btn").attr('data-txt'));
        subscribe_error();
      },
      dataType: "json"
    });
  }

  return false;
}

function validateEmail(email)
{
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function subscribe_error()
{
  alert("Oh no! We experienced an error with your subscription. Please try again.");
}

function swiper_init(elem, index)
{
  var $this = $(elem);
  if(!$this.hasClass("swiper-init"))
  {
    $this.addClass("swiper-init");
    $this.addClass("instance-" + index);
    $this.find(".swiper-button-prev").addClass("btn-prev-" + index);
    $this.find(".swiper-button-next").addClass("btn-next-" + index);
    $this.find(".swiper-pagination").addClass("pagin-" + index);
    var swiper = new Swiper(".instance-" + index, {
      // your settings ...
      pagination: ".pagin-" + index,
      paginationClickable: true,

      nextButton: ".btn-next-" + index,
      prevButton: ".btn-prev-" + index,
      loop: true,
      effect: 'fade',
       autoplay: 8000
    });
    return swiper;
  }

  return null;
}

function update_quantity(id, qty) {
  // Add activity classes when changing cart quantities
  var row = $('.ajaxcart__row[data-line="' + id + '"]').addClass('is-loading');

  if (qty === 0) {
    row.parent().addClass('is-removed');
  }

  // Slight delay to make sure removed animation is done
  setTimeout(function() {
    ShopifyAPI.changeItem(id, qty, ajaxCart.adjustCartCallback);
  }, 250);
}

$(document).ready(function(){

  $(".swiper-container").each(function(index){
    swiper_init($(this), index);
  });

  $(".search-icon").click(function(){
      $('.search').slideToggle(250);
  });


  $('body').on('click', '.accordion-toggle', function(){
      var content = $(".accordion-content");
      var toggle = $(".accordion-toggle");
      var theclick = $(this);

      if( theclick.hasClass('open') ){
      	content.slideUp('fast');
        theclick.toggleClass('open');
      }
      else{
        content.slideUp('fast');
        toggle.removeClass('open');
        theclick.next().slideToggle('fast');
        theclick.toggleClass('open');
      }

  });

  // new overlay added when flyouts are active

  function addOverlay(){
  	setTimeout(function(){
  		$('.overlay-block').fadeIn();
  	},500);
  }

  $('.overlay-block').on('click', function(){
  	$(this).fadeOut();
  });

  $('.js-drawer-close').on('click', function(){
  	$('.overlay-block').fadeOut();
  });

  $('.site-nav--mobile button').on('click', function(){
  	$('.overlay-block').fadeIn();
  });

  $('.js-drawer-open-right').on('click', function(){
  	$('.overlay-block').fadeIn();
  });

  $('.js-drawer-open-right').on('click', function(){
  	$('.overlay-block').fadeIn();
  });

  $('button#AddToCart').on('click', function(){
  // addOverlay();
 });

  //$('.js-drawer-close').click();

  $(".img-alternate").click(function()
	{
		var image_index = 1;
		var img_url = $(this).attr('data-url');
		$(".swiper-slide-thumb").each(function()
		{
			if(!$(this).hasClass("swiper-slide-duplicate"))
			{
				console.log(img_url);
				if($(this).attr('data-url') == img_url)
				{
					if(!$(this).hasClass("swiper-slide-active")) swiper2.slideTo(image_index);
					return false;
				}

				image_index++;
			}
		});
	});

  $('body').on('click', '.cart-remove', function()
    {
        update_quantity($(this).data('id'), 0);
    });

  $('a[href*=#]:not([href=#])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
        || location.hostname == this.hostname) {

        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
           if (target.length) {
             $('html,body').animate({
                 scrollTop: target.offset().top
            }, 300);
            return false;
        }
    }


  });


  var initPhotoSwipeFromDOM = function(gallerySelector) {

    // parse slide data (url, title, size ...) from DOM elements
    // (children of gallerySelector)
    var parseThumbnailElements = function(el) {
        var thumbElements = el.childNodes,
            numNodes = thumbElements.length,
            items = [],
            figureEl,
            linkEl,
            size,
            item;

        for(var i = 0; i < numNodes; i++) {

            figureEl = thumbElements[i]; // <figure> element

            // include only element nodes
            if(figureEl.nodeType !== 1) {
                continue;
            }

            linkEl = figureEl.children[0]; // <a> element

            size = linkEl.getAttribute('data-size').split('x');

            // create slide object
            item = {
                src: linkEl.getAttribute('href'),
                w: parseInt(size[0], 10),
                h: parseInt(size[1], 10)
            };



            if(figureEl.children.length > 1) {
                // <figcaption> content
                item.title = figureEl.children[1].innerHTML;
            }

            if(linkEl.children.length > 0) {
                // <img> thumbnail element, retrieving thumbnail url
                item.msrc = linkEl.children[0].getAttribute('src');
            }

            item.el = figureEl; // save link to element for getThumbBoundsFn
            items.push(item);
        }

        return items;
    };

    // find nearest parent element
    var closest = function closest(el, fn) {
        return el && ( fn(el) ? el : closest(el.parentNode, fn) );
    };

    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function(e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;

        var eTarget = e.target || e.srcElement;

        // find root element of slide
        var clickedListItem = closest(eTarget, function(el) {
            return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
        });

        if(!clickedListItem) {
            return;
        }

        // find index of clicked item by looping through all child nodes
        // alternatively, you may define index via data- attribute
        var clickedGallery = clickedListItem.parentNode,
            childNodes = clickedListItem.parentNode.childNodes,
            numChildNodes = childNodes.length,
            nodeIndex = 0,
            index;

        for (var i = 0; i < numChildNodes; i++) {
            if(childNodes[i].nodeType !== 1) {
                continue;
            }

            if(childNodes[i] === clickedListItem) {
                index = nodeIndex;
                break;
            }
            nodeIndex++;
        }



        if(index >= 0) {
            // open PhotoSwipe if valid index found
            openPhotoSwipe( index, clickedGallery );
        }
        return false;
    };

    // parse picture index and gallery index from URL (#&pid=1&gid=2)
    var photoswipeParseHash = function() {
        var hash = window.location.hash.substring(1),
        params = {};

        if(hash.length < 5) {
            return params;
        }

        var vars = hash.split('&');
        for (var i = 0; i < vars.length; i++) {
            if(!vars[i]) {
                continue;
            }
            var pair = vars[i].split('=');
            if(pair.length < 2) {
                continue;
            }
            params[pair[0]] = pair[1];
        }

        if(params.gid) {
            params.gid = parseInt(params.gid, 10);
        }

        return params;
    };

    var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
        var pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options,
            items;

        items = parseThumbnailElements(galleryElement);

        // define options (if needed)
        options = {

            // define gallery index (for URL)
            galleryUID: galleryElement.getAttribute('data-pswp-uid'),

            getThumbBoundsFn: function(index) {
                // See Options -> getThumbBoundsFn section of documentation for more info
                var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
                    pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                    rect = thumbnail.getBoundingClientRect();

                return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
            }

        };

        // PhotoSwipe opened from URL
        if(fromURL) {
            if(options.galleryPIDs) {
                // parse real index when custom PIDs are used
                // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                for(var j = 0; j < items.length; j++) {
                    if(items[j].pid == index) {
                        options.index = j;
                        break;
                    }
                }
            } else {
                // in URL indexes start from 1
                options.index = parseInt(index, 10) - 1;
            }
        } else {
            options.index = parseInt(index, 10);
        }

        // exit if index not found
        if( isNaN(options.index) ) {
            return;
        }

        if(disableAnimation) {
            options.showAnimationDuration = 0;
        }

        // Pass data to PhotoSwipe and initialize it
        gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
    };

    // loop through all gallery elements and bind events
    var galleryElements = document.querySelectorAll( gallerySelector );

    for(var i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', i+1);
        galleryElements[i].onclick = onThumbnailsClick;
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = photoswipeParseHash();
    if(hashData.pid && hashData.gid) {
        openPhotoSwipe( hashData.pid ,  galleryElements[ hashData.gid - 1 ], true, true );
    }
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


});
